import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100.7 93.7",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: ".st0{fill:#0062FF;}" }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M25.2 8.2L0 24.2l25.2 16 25.1-16zm50.3 0l-25.1 16 25.1 16 25.2-16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M0 56.3l25.2 16 25.1-16-25.1-16.1zm75.5-16.1L50.3 56.3l25.2 16 25.2-16zM25.2 77.7l25.1 16 25.2-16-25.2-16.1z"
		})
	]
});
export default SvgDropbox;
